import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'hvilken-skade':
            return 'dato';
        case 'dato':
            return 'hvor-skete-skaden';

        case 'hvor-skete-skaden':
            return 'om-skaden';

        case 'om-skaden':
            return 'dokumentation';

        case 'dokumentation':
            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            }

            return 'om-dig';

        case 'hvilket-selskab':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        case 'resume':
            return undefined;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
